import React, { useRef, useEffect } from 'react';

const Pedestrian = props => {
    return (
        <>
          <div className='pedVolData' style={{position:'absolute',top:'0'}}>
            <span className='amNbWalk'>{props.pedestrianData.pedNb}</span>
            <span className='amSbWalk'>{props.pedestrianData.pedSb}</span>
            <span className='amEbWalk'>{props.pedestrianData.pedEb}</span>
            <span className='amWbWalk'>{props.pedestrianData.pedWb}</span>
          </div>
        </>
    )
}
export default Pedestrian;